import { useParams } from "react-router-dom";
import Button from "components/Elements/Button/Button.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import GetTransformedDate, {
  useTransofrmedDate,
} from "utils/dateViewTransformer.tsx";
import calculateLinkRenewablePage from "helpers/calculateLinkRenewablePage.ts";
import useSubscriptionExpiration from "hooks/useSubscriptionExpiration.ts";
import useMediaQueries from "hooks/useMediaQueries.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUser } from "contexts/userContext/userContext.js";

const HeaderToast = ({ closeToast, notExistEmbedPage, typeOfDisplayToast }) => {
  const params = useParams();
  const { currDayIsExpirationDay, gracePeriod } = useSubscriptionExpiration();
  const { newMobileCondition } = useMediaQueries();
  const { getTextByKey, getPath, getDirection } = useContent();
  const {
    getUserData,
    premiumExpired,
    getUserBillingDetails,
    getIsPendingLogin,
  } = useUser();
  const userData = getUserData();

  const userBillingDetails = getUserBillingDetails();

  const { returnDate: requestDate } = useTransofrmedDate({
    date: userBillingDetails?.requestToStopSubscriptionDate,
    fullView: true,
    showDay: false,
  });

  const { returnDate: cancelDate } = useTransofrmedDate({
    date: userBillingDetails?.endDate,
    fullView: true,
    showDay: false,
  });

  if (getIsPendingLogin()) {
    return null;
  }

  const dateExpired = GetTransformedDate({
    date: userData.Subscribtion_Expired,
    fullView: true,
    showDay: false,
  });
  const subscriptionExpirationDate = new Date(userData.Subscribtion_Expired);

  const today = new Date();
  const diffTime =
    typeOfDisplayToast === "expired"
      ? Math.abs(today - subscriptionExpirationDate)
      : typeOfDisplayToast === "aboutToExpired"
      ? Math.abs(subscriptionExpirationDate - today)
      : null;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  const isFormManagementPage =
    params.profileCategory === "jumbo-forms" &&
    params.profilePage === "form-management";
  const typeAlert =
    typeOfDisplayToast === "expired"
      ? "error"
      : typeOfDisplayToast === "aboutToExpired"
      ? "warning"
      : "";

  const textToast =
    typeOfDisplayToast === "expired"
      ? getTextByKey("renew-old-subscription-text").replace(
          "#DaysLeft#",
          gracePeriod?.daysLeft
        )
      : "";

  const titleToast =
    userBillingDetails?.cancelType === "cancel-immediately"
      ? getTextByKey("subscription-canceled-immediately-title")
          .replace("#request-date#", requestDate)
          .replace("#cancel-date#", cancelDate)
      : currDayIsExpirationDay && typeOfDisplayToast !== "expired"
      ? getTextByKey("Subscription-expires-today")
      : typeOfDisplayToast === "expired"
      ? getTextByKey("renew-old-subscription-title").replace(
          "#Date#",
          dateExpired
        )
      : typeOfDisplayToast === "aboutToExpired"
      ? getTextByKey("profileuser-subscription-expiration-text") +
        " " +
        diffDays +
        " " +
        getTextByKey("profileuser-subscription-expiration-days-text")
      : "";

  const buttonLink = calculateLinkRenewablePage(
    userBillingDetails?.period,
    userData.EmbedSubscription,
    userData.Subscription,
    getPath()
  );

  const displayToastMode =
    isFormManagementPage && notExistEmbedPage ? false : true;

  return displayToastMode ? (
    <div
      className={`profile-header-toast ${
        newMobileCondition ? "mobile-toast-header" : ""
      }`}
    >
      {newMobileCondition ? (
        <div className="header-toast">
          <div
            className={`close-toast ${
              getDirection() === "rtl" ? "rtl-close" : ""
            }`}
            onClick={() => closeToast()}
          >
            <Icon name="x" />
          </div>
          <div
            className={`line-toast ${typeAlert} ${
              getDirection() === "rtl" ? "rtl-line" : ""
            }`}
          ></div>
          <div className={`icon-toast ${typeAlert}`}>
            <Icon name="triangular-info" />
          </div>
          <div className="body-toast">
            <div className="content-toast">
              <div className="title-toast">
                <h3>{titleToast}</h3>
              </div>
              {textToast && <div className="text-toast">{textToast}</div>}
              {premiumExpired() && typeAlert === "error" && (
                <div className="jumbopage-text">
                  {getTextByKey("subscription-expired-jumbopage-alert")}
                </div>
              )}
            </div>
            {userBillingDetails?.cancelType !== "cancel-immediately" && (
              <div className="toast-button">
                <a href={buttonLink} target="_blank" rel="noreferrer">
                  <Button className="embed-button-white-text">
                    {getTextByKey("renew-old-subscripition-button")}
                  </Button>
                </a>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="header-toast">
          <div
            className={`close-toast ${
              getDirection() === "rtl" ? "rtl-close" : ""
            }`}
            onClick={() => closeToast()}
          >
            <Icon name="x" />
          </div>
          <div
            className={`line-toast ${typeAlert} ${
              getDirection() === "rtl" ? "rtl-line" : ""
            }`}
          ></div>
          <div className="body-toast">
            <div className={`icon-toast ${typeAlert}`}>
              <Icon name="triangular-info" />
            </div>
            <div className="content-toast">
              <div className="title-toast">
                <h3>{titleToast}</h3>
              </div>
              {textToast && <div className="text-toast">{textToast}</div>}
              {premiumExpired() && typeAlert === "error" && (
                <div className="jumbopage-text">
                  {getTextByKey("subscription-expired-jumbopage-alert")}
                </div>
              )}
            </div>
          </div>
          {userBillingDetails?.cancelType !== "cancel-immediately" && (
            <div className="toast-button">
              <a href={buttonLink} target="_blank" rel="noreferrer">
                <Button className="embed-button-white-text">
                  {getTextByKey("renew-old-subscripition-button")}
                </Button>
              </a>
            </div>
          )}
        </div>
      )}
    </div>
  ) : null;
};

export default HeaderToast;
